<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Income Drivers</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="vertical-flex">
                  <p class="mt-3">
                    Income drivers represent your main sources of revenue. To keep things simple, Sinchii lets you group these into three main categories of your choosing.
                  </p>
                  <img src="@/assets/images/income-drivers.png" alt="Example Income Drivers" class="img-fluid" />
                  <p class="mt-4">
                    If your monthly revenue is higher or lower during certain parts of the year, you can adjust the seasonality percentage to account for this. You can update these settings anytime.
                  </p>
                  <img src="@/assets/images/seasonality-income.png" alt="Example Income Seasonality" class="img-fluid form-center" />
                  <p class="mt-5">
                    Fill in your income drivers set to get started.
                  </p>
                  <p class="mt-3">
                    For more information about income drivers and how to use Sinchii, click <a href="https://sinchii.com.au/resources/" target="_blank">here</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="close">Let's Begin</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../Icon.vue";

export default {
  components: {
    icon
  },
  methods: {
    close() {
      this.$emit("onClose");
    }
  }
};

</script>
